<template>
    <v-container ref="pageActions" fluid tag="section">

        <material-card icon="mdi-clipboard-text" icon-small title="FAQ теми" color="accent" class="mb-16">

            <!--Таблица-->
            <v-data-table :headers="headers" :items="items" class="elevation-1" :search="search"
                :footer-props="{ itemsPerPageOptions: [5, 10, 20, 50, 100, -1] }" :options="{ itemsPerPage }">
                <template v-slot:item.image="{ item }">
                    <v-img contain height="100" width="100" :src="`${imageBaseUrl}${item.image}`"></v-img>
                </template>
                <template v-slot:item.is_active="{ item }">
                    <v-icon v-if="item.is_active" color="green">mdi-check-circle</v-icon>
                    <v-icon v-else color="red">mdi-close-circle</v-icon>
                </template>

                <template v-slot:item.action="{ item }">
                    <v-btn icon :to="`/faq-themes/${item.id}`">
                        <v-icon color="blue">mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn icon @click="deleteBanner(item)">
                        <v-icon color="red">mdi-delete</v-icon>
                    </v-btn>
                </template>
            </v-data-table>
            <!--Диалоговое окно для удаления-->
            <DialogConfitmDelete ref="dialogConfirmDelete" />
            <Preloader v-if="isSending" />
        </material-card>

        <v-btn v-if="isManager || isAdmin" class="add-user__button" fab dark color="primary" to="/faq-themes/add/">
            <v-icon dark>
                mdi-plus
            </v-icon>
        </v-btn>

    </v-container>
</template>

<script>
import { HTTP } from '@/http-common';
import { mapGetters, mapMutations, mapActions } from 'vuex'


export default {
    name: 'RegularTablesView',
    data() {
        return {
            // Текущий проект
            project: {},
            // Количество элементов на странице
            itemsPerPage: 50,
            // Количество страниц
            isSending: false,
            headers: [
                { text: 'ID', value: 'id' },
                { text: 'Назва', value: 'name' },
                { text: 'Вкл.', value: 'is_active' },
                { text: 'Порядок', value: 'order'},
                { text: 'Управління', value: 'action', sortable: false },
            ],
            items: [],
            search: '',
        }
    },
    computed: {
        ...mapGetters(['isManager', 'isAdmin', 'projects']),
    },

    mounted() {
        this.init();
    },

    watch: {
        // '$route': {
        //     handler() {
        //         this.getActions();
        //     },
        //     deep: true,
        // }
    },

    methods: {
        ...mapMutations(['setSnackbar']),

        async init() {
            await this.getList();

        },
        async getList() {
            this.isSending = true;
            try {
                let { data } = await HTTP.post('/get-faq-themes-list', {});
                this.items = data.content;
            } catch (e) {
                this.setSnackbar({ color: 'error', text: e.message || e });
            } finally {
                this.isSending = false;
            }
        },
        setQueryParam() {
            this.getList();
        },
        async deleteBanner(item) {
            let isConfirmDelete = await this.$refs.dialogConfirmDelete.callDialog();
            if (!isConfirmDelete) return;
            this.isSending = true;

            try {
                await HTTP.post('/delete-faq-theme', { id: item.id });
                await this.getList();
            } catch (e) {
                this.setSnackbar({ color: 'error', text: e.message || e });
            } finally {
                this.isSending = false;
            }
        },
    },
}

</script>

<style>
.add-user__button {
    position: fixed;
    bottom: 20px;
    right: 20px;
}
</style>
